import PageHeading from '../components/common/PageHeading';

function MyPage({ isAuthenticated }) {
  return (
    <section className="page-section" aria-labelledby="my-title">
      <PageHeading
        id="my-title"
        label="내 공간"
        title="내 예약과 강습 기록"
        description="예약 현황, 강습 내역, 개인 알림처럼 본인 확인이 필요한 정보를 모아봅니다."
      />
      <div className="account-panel">
        <div>
          <span className="status-dot" aria-hidden="true" />
          <strong>{isAuthenticated ? '로그인됨' : '로그인 필요'}</strong>
        </div>
        <p>로그인 후 예약 내역과 맞춤 알림을 확인할 수 있습니다.</p>
      </div>
    </section>
  );
}

export default MyPage;
